import styled, { css } from 'styled-components';
import InputSkeleton from '../components/input-skeleton';
import TextareaAutosize from 'react-textarea-autosize';

export const InputSkeletonSC = styled(InputSkeleton)`
  :hover {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'text')};
  }

  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)} !important;

  &.ui-textarea {
    .input-skeleton-content {
      margin: 0 !important;
    }
  }
`;

const inputStyles = (variant?: 'on-dark' | 'on-light') => css`
  flex: 1;
  margin: 0;
  padding: 0;
  min-height: 100%;
  width: 100%;

  border: none;
  background: none;
  outline: none;
  box-shadow: none;
  ${({ theme }) => theme.mappedTypography.body2.strong};
  color: ${({ theme }) => theme.color.tint.primary};

  ::placeholder {
    color: ${({ theme }) =>
      variant === 'on-dark' ? theme.color.tint.tertiaryDark : theme.color.tint.tertiary};
  }

  .on-dark & {
    color: ${({ theme }) => theme.color.tint.primaryDark};
    :focus {
      color: ${({ theme }) => theme.color.tint.selection};
    }
    ::placeholder {
      color: ${({ theme }) => theme.color.tint.tertiaryDark};
    }
  }

  :disabled,
  :read-only {
    cursor: not-allowed;
  }

  .ui-textarea & {
    padding: 8px 12px;
  }
`;

export const InputSC = styled.input<{ variant?: 'on-dark' | 'on-light' }>`
  ${({ variant }) => inputStyles(variant)};
`;

export const InputAreaSC = styled(TextareaAutosize)<{ variant?: 'on-dark' | 'on-light' }>`
  ${({ variant }) => inputStyles(variant)};
`;
